const ChevronUp = () => {
    return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1000 1000">
        <path d="M32.1,712.6l453.2-452.2c11-11,21-11,32,0l453.2,452.2c4,5,6,10,6,16c0,13-10,23-22,23c-7,0-12-2-16-7L501.3,308.5 L64.1,744.7c-4,5-9,7-15,7c-7,0-12-2-17-7C23.1,733.7,23.1,723.7,32.1,712.6z"/>
    </svg>);
};
export default ChevronUp;
